import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiImageService {
  private apiKey = environment.STABILITY_API_KEY;

  constructor(private http: HttpClient) {}

  generateFromText(prompt: string) {
    const payload = {
      key: this.apiKey,
      message: prompt,
      negative_prompt: '',
      width: '1024',
      height: '1024',
      samples: '1',
      num_inference_steps: '30',
      guidance_scale: 7.5
    };

    return this.http.post('https://stablediffusionapi.com/api/v3/text2img', payload);
  }

  generateFromImage(base64Image: string, prompt: string) {
  // Remove base64 prefix
    const cleanBase64 = base64Image.replace(/^data:image\/(png|jpeg);base64,/, '');

    const payload = {
      key: this.apiKey,
      init_image: cleanBase64,  // Must be raw base64 without prefix
      prompt: prompt,           // Use "prompt", not "message"
      width: "512",             // 512x512 works more reliably with some models
      height: "512",
      samples: "1",
      num_inference_steps: "30",
      guidance_scale: 7.5,
      strength: 0.6              // Try 0.6+ for better transformation
    };

    return this.http.post('https://stablediffusionapi.com/api/v3/img2img', payload);
  }



  convertImageToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!file.type.startsWith('image/')) {
        reject('Only image files are supported.');
        return;
      }

      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

}
